export default function Calendar(Restangular, EventCollection, extendCalendarModel, sdk) {
  'ngInject';

  Restangular.extendModel('calendar', (model) => {
    const result = extendCalendarModel(model);

    if (result.type === 'shift' || result.type === sdk('constants').NO_SHOW_TYPE) {
      return Restangular.restangularizeElement(null, result, 'shifts');
    }

    if (EventCollection.isTimeOff(result.type)) {
      return Restangular.restangularizeElement(null, result, 'leave');
    }

    if (result.type === 'suppression') {
      return Restangular.restangularizeElement(null, result, 'leave/suppress');
    }

    if (result.type === 'availability') {
      return Restangular.restangularizeElement(null, result, 'availability');
    }
  });

  return Restangular.service('calendar');
}
